var chunkMapping = {
	"2559": [
		62559
	],
	"3167": [
		83167
	],
	"4236": [
		74236
	],
	"4873": [
		54873
	],
	"5258": [
		15258
	],
	"7868": [
		47868
	],
	"9378": [
		59378
	]
};
var idToExternalAndNameMapping = {
	"15258": [
		"default",
		"./Conversations",
		77029
	],
	"47868": [
		"default",
		"./Styles",
		77029
	],
	"54873": [
		"default",
		"./Tags",
		77029
	],
	"59378": [
		"default",
		"./McpServers",
		77029
	],
	"62559": [
		"default",
		"./Audit",
		77029
	],
	"74236": [
		"default",
		"./Agents",
		77029
	],
	"83167": [
		"default",
		"./Tools",
		77029
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}